import {cancel, HybirdBridge, invoke, on} from "@hybird/core/bridge/hybirdBridge";
import {BridgeMethod} from "@hybird/core/bridge/core";

export class FlutterWIFI extends BridgeMethod {

  constructor() {
    super();
  }

  onWifiScan(callback) {
    return on("onWifiScan", callback, {isSend: true});
  }

  offWifiScan(callback) {
    return cancel("onWifiScan", {event: callback, isSend: true});
  }

  async getWifiScannedResults() {
    return invoke("getWifiScannedResults");
  }

  async setWifiEnabled(enable = true) {
    return invoke("setWifiEnabled", {
      params: {
        enable
      }
    });
  }

  /**
   *
   * @param ssid{String}
   * @param password{String}
   * @param security{String} WPA|WEP|NONE
   * @param joinOnce
   * @param withInternet
   * @param isHidden
   * @return {Promise<Object>}
   */
  async connectWifi({ssid, password, security = "WPA", joinOnce = false, withInternet = true, isHidden = false}) {
    return invoke("connectWifi", {params: {ssid, password, security, joinOnce, withInternet, isHidden}});
  }

  async getCurrWifiInfo() {
    return invoke("getCurrWifiInfo");
  }
}

export const flutterWIFI = new FlutterWIFI();